var map = {
	"./additionalInfoIcon.svg": 650,
	"./arrowLeftIcon.svg": 651,
	"./arrowMediumTop.svg": 652,
	"./arrowRightIcon.svg": 653,
	"./arrowRightIconSharp.svg": 654,
	"./arrowRightSmallIcon.svg": 655,
	"./arrowScalableIcon.svg": 656,
	"./arrowSelect2.svg": 657,
	"./arrowSelectIcon.svg": 658,
	"./benefit1.svg": 659,
	"./benefit2.svg": 660,
	"./benefit3.svg": 661,
	"./cardsIcon.svg": 662,
	"./crossIcon.svg": 663,
	"./crossIcon2.svg": 664,
	"./crossIcon3.svg": 665,
	"./crossIconSmall.svg": 666,
	"./crossSmallIcon.svg": 667,
	"./defaultCategoryIcon.svg": 668,
	"./depNumberIcon.svg": 669,
	"./elfCentralIcon.svg": 670,
	"./equalitySign.svg": 671,
	"./errorIcon.svg": 385,
	"./eyeClosedIcon.svg": 672,
	"./eyeOpenIcon.svg": 673,
	"./favoritesIcon.svg": 674,
	"./favoritesLabelIcon.svg": 675,
	"./filterDivider.svg": 676,
	"./filterIcon.svg": 677,
	"./frequencyIcon.svg": 678,
	"./fsAmountIcon.svg": 679,
	"./fullScreenIcon.svg": 680,
	"./gameIcon.svg": 681,
	"./hamburgerIcon.svg": 682,
	"./infoIcon.svg": 683,
	"./infoSymbol.svg": 684,
	"./levelBackground.svg": 685,
	"./levelBackgroundNew.svg": 686,
	"./lockIcon.svg": 687,
	"./maxBonusAmountIcon.svg": 688,
	"./maxWinFsIcon.svg": 689,
	"./menuIcon.svg": 690,
	"./minDepIcon.svg": 691,
	"./noTournamentIcon.svg": 692,
	"./playIcon.svg": 693,
	"./polygon.svg": 694,
	"./preloaderDotsAnimation.svg": 695,
	"./preloaderSpinnerAnimation.svg": 696,
	"./promoIcon.svg": 697,
	"./recentIcon.svg": 698,
	"./search2Icon.svg": 699,
	"./search3Icon.svg": 700,
	"./smallInfoSymbol.svg": 701,
	"./successIcon.svg": 702,
	"./supportIcon.svg": 703,
	"./tag1Icon.svg": 704,
	"./tag2Icon.svg": 705,
	"./tag3Icon.svg": 706,
	"./tag4Icon.svg": 707,
	"./tickIcon.svg": 708,
	"./unverified.svg": 709,
	"./verified.svg": 710,
	"./wagerIcon.svg": 711,
	"./wagerTimeIcon.svg": 712,
	"./warningIcon.svg": 713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 649;